/**
 * lity 插件视频容灾处理
 * @param videoId
 * @param facebookUserName
 */
const lityVideo = (videoId, facebookUserName = "") => {
  let platform = "youtube";
  facebookUserName = facebookUserName
    ? facebookUserName
    : window.__facebookUserName;
  //   platform fix
  if (videoId && videoId.match) {
    if (videoId.match(/^[\d]+$/)) {
      if (videoId.length === 16) {
        platform = "facebook";
      } else {
        platform = "vimeo";
      }
    } else {
      platform = "youtube";
    }
  }

  switch (platform) {
    case "youtube":
      window.lity(
        `https://www.youtube.com/watch?v=${videoId}&html5=1&autoplay=1&rel=0&showinfo=0&enablejsapi=1&widgetid=0`
      );
      break;
    case "facebook":
      window.lity(
        `https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2F${encodeURIComponent(
          facebookUserName
        )}%2Fvideos%2F${videoId}%2Fautoplay=true`
      );
      break;
    case "vimeo":
      window.lity(`https://vimeo.com/${videoId}`);
      break;
  }
};

/**
 * 延迟操作
 * @param ms
 * @returns {Promise<any>}
 */
const timeout = (ms = 300) => {
  return new Promise((res) => {
    window.setTimeout(() => {
      res();
    }, ms);
  });
};

/**
 * 将一个style写入页面
 * @param styleClass
 * @param content
 */
const write_style = (styleClass, content) => {
  if ($(`.${styleClass}`).length === 0) {
    let oStyleEl = $(`<style class="${styleClass}" />`);
    $("head").append(oStyleEl);
  }

  let oStyle = $(`.${styleClass}`).eq(0);
  oStyle.html(content);
};

/**
 * 获取元素 rotate 的 angle 值
 * @param element
 */
const getPureRotation = (element) => {
  let matrix = $(element).css("transform");
  let angle = 0;
  if (matrix !== "none") {
    let values = matrix.split("(")[1].split(")")[0].split(",");
    angle = Math.round(Math.atan2(values[1], values[0]) * (180 / Math.PI));
  }
  return angle < 0 ? angle + 360 : angle;
};

/**
 * 获取元素的translateX/Yy
 * @param el
 * @returns {[]|number}
 */
const getComputedTranslateXY = (el) => {
  const transArr = [];
  if (!window.getComputedStyle) return;
  const style = getComputedStyle(el),
    transform = style.transform || style.webkitTransform || style.mozTransform;
  let mat = transform.match(/^matrix3d\((.+)\)$/);
  if (mat) return parseFloat(mat[1].split(", ")[13]);
  mat = transform.match(/^matrix\((.+)\)$/);
  mat ? transArr.push(parseFloat(mat[1].split(", ")[4])) : 0;
  mat ? transArr.push(parseFloat(mat[1].split(", ")[5])) : 0;
  return transArr;
};

/**
 * 获取元素的属性值
 * @param el - 元素
 * @returns {[]|object}
 */

const getStyle = (el) => {
  // currentStyle 为兼容IE的写法
  return window.getComputedStyle ? getComputedStyle(el, null) : el.currentStyle;
};

/**
 * 获取当前域名(带二级语言目录判断)
 */
const getHost = () => {
  let host = location.host;
  let arr = location.pathname.match(/^\/\w\w\//);
  if (arr) {
    return (host + arr[0]).slice(0, -1);
  }
  return host;
};

/**
 * 判断是否为父级, 如果同时存在子级的话, 让他加个文件路径
 * @param routeName 当前路由的名字
 * 比如 six-trials-of-God-s-judgment-work 他有子级
 * 那么他的文件路径应该是 /six-trials-of-God-s-judgment-work/index.json
 * return string
 */
const checkRoutePath = (path, asideData) => {
  if (path === "" || path === "/") {
    return "/home";
  } else {
    let routeName = path.slice(1).split("/").pop();

    let currentObj = asideData.find((item) => item.slug === routeName);
    if (currentObj && currentObj.children.length > 1) {
      path = path + "/index";
    }
    return path;
  }
};

/**
 * 获取当前的语言代码
 */
const get_lang = () => {
  let host = location.host;
  let pathArr = location.pathname.match(/^\/\w\w\//);
  let lang = "";
  if (process.env.NODE_ENV === "production") {
    if (host.includes("www")) {
      if (pathArr) {
        lang = pathArr[0].split("/")[1];
      } else {
        if (host.includes("holyspiritspeaks")) {
          lang = "en";
        } else if (host.includes("godfootsteps")) {
          lang = "tr";
        } else {
          lang = "zh";
        }
      }
    } else {
      lang = host.split(".")[0];
    }
  } else {
    lang = process.env.VUE_APP_LANG;
  }

  return lang;
};

const replace_to_webp = (path) => {
  return path.replace(/\.(jpg|png)$/, ".$1.webp");
};

/**
 * 处理 资源文件 本地化与国际化问题
 * images/introduction/bg-0.jpg|useWebp=false  可以通过 | 来传递参数, 结构与query search一样
 */
const i18n = (path) => {
  let configsArray = path.split("|");
  let config = {
    useWebp: true,
  };

  if (configsArray.length > 1) {
    path = configsArray[0];
    let newConfig = configsArray[1]
      .split("&")
      .map((p) => p.split("="))
      .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

    config = Object.assign(config, newConfig);

    Object.keys(config).map((key) => {
      if (config[key] === "false" || config[key] === "true") {
        config[key] = JSON.parse(config[key]);
      }
    });
  }

  if (path.includes("kingdomsalvation")) return path;
  //  若在多语言路径中找到此路径, 将切换文件夹
  let multilingualAssetFileRules = ["loading/title.png", "common/logo.svg"];
  if (multilingualAssetFileRules.includes(path)) {
    path = `${get_lang()}/${path}`;
  }

  //  如果浏览器支持, 使用webp格式
  if (window.__supportWebp && config.useWebp) {
    path = replace_to_webp(path);
  }
  return (
    (process.env.NODE_ENV === "production"
      ? "https://centereu.kingdomsalvation.org/cdn/v3/topics/photo-exhibition2.0/assets/"
      : process.env.VUE_APP_CDN) + path
  );
};

//  todo 下载英文数据包, 看safari问题

/**
 * 通过slug获取手绘图的链接
 * @param slug
 * @returns {{min: *, max: *}}
 */
const getPaintImagePath = (slug) => {
  let absLink = "images/paint/";

  //    路径拼接
  let min = absLink + slug + "-md.jpg";
  let max = absLink + slug + ".jpg";
  if (window.__supportWebp) {
    min = replace_to_webp(min);
    max = replace_to_webp(max);
  }

  if (!slug) {
    min = max = "";
  }

  return { min, max };
};

const getStorage = (key) => {
  if ("localStorage" in window) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return "";
    }
  }
};

const setStorage = (key, value) => {
  if ("localStorage" in window) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return "";
    }
  }
};

/**
 * 渲染一张图片
 * @param img
 * @returns {Promise<any>}
 */
const renderImage = (img) => {
  return new Promise((res) => {
    let ImgObj = new Image();
    ImgObj.onload = () =>
      res({
        width: ImgObj.width,
        height: ImgObj.height,
      });
    ImgObj.onerror = (err) => {
      // console.log(img, err);
    };
    ImgObj.src = img;
  });
};

/**
 * 获取滚动条宽度
 * 思路:
 *  创建俩DIV为父子级关系, 父级添加溢出滚动属性, 此时父级的宽度 - 子集的宽度 就是scrollbar的宽度
 * @returns {number}
 */
const get_scroll_bar_width = () => {
  let oDiv = document.createElement("div");
  oDiv.style.visibility = "hidden";
  oDiv.style.overflow = "scroll";
  oDiv.style.msOverflowStyle = "scrollbar";
  document.body.appendChild(oDiv);
  let insideDiv = document.createElement("div");
  oDiv.appendChild(insideDiv);
  let scrollbarWidth = oDiv.offsetWidth - insideDiv.offsetWidth;
  oDiv.parentNode.removeChild(oDiv);

  return scrollbarWidth;
};

/**
 * 通过npm run --获取参数
 * npm run script --foo:bar
 * getParameterFromNpmScript('foo') === bar
 * @param key
 * @returns {undefined|*}
 */
const getParameterFromNpmScript = (key) => {
  let keyName = key === "lang" ? `VUE_APP_LANG` : "VUE_APP_SECOND_FOLDER";
  //    此处通过process.env判断变量是否存在
  //    注! 这里有个坑, 代码运行环境时无法通过 process.env.npm_config_argv 获取参数, vue-cli也未处理这块
  //    但是vue-cli提供了另外一种传参的方法
  //    .env文件
  //    这个链接具体说明了如何使用
  //    https://cli.vuejs.org/zh/guide/mode-and-env.html
  //    这里为了兼容编译环境与运行环境获取参数方式不同的问题,
  //    在运行 npm script中做了处理
  //    你可以在 package.json ->> script 中看到一下代码
  //        "serve": "node ./parameter.js && vue-cli-service serve",
  //        "build": "node ./parameter.js && vue-cli-service build && node ./build.js"
  //    在执行调用之前, 都会先执行 parameter.js 该文件的作用就是首先获取编译环境中的参数, 然后将其写入到 .env文件中
  //    这样在运行环境中就可以调用npm run -- 时传入的参数了
  if (process.env[keyName] && process.env[keyName] !== "0") {
    return process.env[keyName];
  } else {
    return false;
  }
};

/**
 * 将 rgb 色值 转换为 hsl
 * @param rgbArr  [37, 24, 15]
 * @returns {[number, number, number]}
 */
const rgbToHsl = (rgbArr) => {
  let [r, g, b] = rgbArr;
  (r /= 255), (g /= 255), (b /= 255);
  let max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h,
    s,
    l = (max + min) / 2;

  if (max == min) {
    h = s = 0; // achromatic
  } else {
    let d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return [h, s, l];
};

/**
 * 检查元素是否overflow
 * @param el
 * @returns {boolean}
 */
const checkOverflow = (el) => {
  let curOverflow = el.style.overflow;

  if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";

  let isOverflowing =
    el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

  el.style.overflow = curOverflow;

  return isOverflowing;
};

/**
 * 添加 enjoyhint 遮罩
 * @param selector
 */
const addEnjoyhintMask = (selector) => {
  $(".enjoyhint-mask").remove();
  let rect = $(selector).get(0).getBoundingClientRect();
  let div = document.createElement("div");
  let marginOfError = 20;
  $(div)
    .css({
      width: rect.width + marginOfError,
      height: rect.height + marginOfError,
      left: rect.left - marginOfError / 2,
      top: rect.top - marginOfError / 2,
    })
    .addClass("enjoyhint-mask");

  $(document.body).append(div);
};

/**
 * 从时代中分离"年"与"年至今"
 * 主要用途为处理字体大小问题
 */
const splitTheYearsFromPeriodGive = (Period) => {
  if (~Period.indexOf("年至今")) {
    return Period.replace("年至今", "<span class='year'>年至今</span>");
  } else {
    return Period.replace("年", "<span class='year'>年</span>");
  }
};

/**
 * 生成 uuidv4
 * @returns {string}
 */
const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * 获取测试环境与正式环境兼容的folder名称
 */
const get_fixed_project_folder = () => {
  return ~window.location.pathname.indexOf("picture-exhibition-new")
    ? "picture-exhibition-new"
    : "picture-exhibition";
};

/**
 * 获取字符串实际所渲染出来的宽度
 * @param text
 * @param fontSize
 */
const get_text_outer_width = (text, fontSize = 16) => {
  let $div = $("<div />");
  $div.css({
    "white-space": "nowrap",
    "font-size": `${fontSize}px`,
    opacity: 0,
    position: "fixed",
    transform: `translateZ(0)`,
    left: 0,
    top: 0,
  });
  $div.html(text);

  $(document.body).append($div);
  $div.offset();
  let width = $div.outerWidth();
  $div.remove();
  return width;
};

export {
  splitTheYearsFromPeriodGive,
  addEnjoyhintMask,
  get_fixed_project_folder,
  get_text_outer_width,
  lityVideo,
  get_lang,
  checkRoutePath,
  i18n,
  timeout,
  setStorage,
  getStorage,
  getStyle,
  renderImage,
  get_scroll_bar_width,
  getParameterFromNpmScript,
  getPaintImagePath,
  getPureRotation,
  getHost,
  getComputedTranslateXY,
  rgbToHsl,
  write_style,
  checkOverflow,
  uuidv4,
};
